export default "/images/inbox.svg?ecc13d6312bef146aef062fc394ab4b7";